// extracted by mini-css-extract-plugin
module.exports = {"skills":"About_skills__2tIbP","about-person":"About_about-person__1qALH","bars":"About_bars__bAjlw"};